import GrafanaIcon from './GrafanaIcon';
import KibanaIcon from './KibanaIcon';
import NomadIcon from './NomadIcon';
import AwsIcon from './AwsIcon';
import GithubIcon from './GithubIcon';
import KubernetesIcon from './KubernetesIcon';
import RedisIcon from './RedisIcon';
import MongoDbIcon from './MongoDbIcon';
import ClosedDropdownIcon from './CloseDropdownIcon';
import OpenedDropdownIcon from './OpenedDropdownIcon';
import OpenInNewIcon from './OpenInNewIcon';
import PencilIcon from './PencilIcon';
import LinkIcon from './LinkIcon';
import CogIcon from './CogIcon';
import StarIcon from './StarIcon';
import HelpCircleIcon from './HelpCircleIcon';
import MagnifyIcon from './MagnifyIcon';
import ShapeOutlineIcon from './ShapeOutlineIcon';
import CubeOutlineIcon from './CubeOutlineIcon';
import AccountCogIcon from './AccountCog';
import AdminPortalIcon from './AdminPortalIcon';
import AccessControlIcon from './AccessControlIcon';
import AppManagementIcon from './AppManagementIcon';
import EnvManagementIcon from './EnvManagementIcon';
import AspDashboardIcon from './AspDashboardIcon';
import PrometheusIcon from './PrometheusIcon';
import DeploymentManagementIcon from './DeploymentManagementIcon';
import FilterIcon from './FilterIcon';

export const Icons = {
  AccessControlIcon,
  AspDashboardIcon,
  GrafanaIcon,
  KibanaIcon,
  NomadIcon,
  AwsIcon,
  GithubIcon,
  KubernetesIcon,
  RedisIcon,
  MongoDbIcon,
  ClosedDropdownIcon,
  OpenedDropdownIcon,
  OpenInNewIcon,
  PencilIcon,
  LinkIcon,
  CogIcon,
  StarIcon,
  HelpCircleIcon,
  MagnifyIcon,
  ShapeOutlineIcon,
  CubeOutlineIcon,
  AccountCogIcon,
  AdminPortalIcon,
  AppManagementIcon,
  EnvManagementIcon,
  PrometheusIcon,
  DeploymentManagementIcon,
  FilterIcon,
};
